import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-truck_on_line",
  "use": "icon-truck_on_line-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-truck_on_line\">\r\n<path fill=\"#01BC78\" d=\"M87.562,43.953c-19.302,0-34.952,15.649-34.952,34.951s15.65,34.951,34.952,34.951\r\n\tc19.303,0,34.953-15.649,34.953-34.951S106.864,43.953,87.562,43.953L87.562,43.953z M87.562,107.303\r\n\tc-15.685,0-28.399-12.715-28.399-28.398s12.714-28.397,28.399-28.397s28.399,12.714,28.399,28.397S103.246,107.303,87.562,107.303z\r\n\t M54.456,102.596v0.865H33.479v6.992h28.358C59.041,108.17,56.56,105.529,54.456,102.596z\" />\r\n<path fill=\"#01BC78\" d=\"M47.011,82.484H18.215v-55.81h86.467v15.29c4.822,2.238,9.131,5.392,12.706,9.239V14.481H5.509v79.813\r\n\th44.357C48.354,90.598,47.372,86.63,47.011,82.484z\" />\r\n<path fill=\"#01BC78\" d=\"M103.103,63.006l-19.257,19.24l-8.984-8.979l-6.422,6.415l15.406,15.396l25.679-25.659L103.103,63.006z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/truck_on_line.svg
// module id = 4b/t
// module chunks = 138